import React from "react";
import {CCol, CFormInput, CFormLabel, CFormText, CRow} from "@coreui/react";
import {useDispatch, useSelector} from "react-redux";
import {applyFilter} from "../../store/slice/component/table";

const CreatedUserSearch = () => {
    const dispatch = useDispatch([]);
    const data = useSelector(state => state.entities.component_table);
    return <>
        <CRow className={'mb-1'}>
            <CCol>
                <CFormLabel>Entity Owner User</CFormLabel>
                <CFormInput type="text"
                            onChange={(e) => {
                                dispatch(applyFilter({
                                    field_name: 'created_by_name',
                                    value: e.target.value,
                                }));
                            }}
                            defaultValue={data.created_by_name || ''}
                />
                <CFormText>Example: Vidhya, Manthan (It can be created by or transaction responsible)</CFormText>
            </CCol>
        </CRow>
    </>;
}

export default CreatedUserSearch;
